module.exports = __webpack_public_path__ + "img/04.405fa0fb.jpg";